import { type Device, useSupabase } from "../contexts/SupabaseContext";

export type { Device };

// Wrapper hook to access device state from context
export function useUserDevices() {
    const { devices, devicesLoading, devicesKnown, revokeDevice, revokeAllDevices, revokingId, revokingAll } = useSupabase();

    return {
        devices,
        loading: devicesLoading,
        known: devicesKnown,
        revokeDevice,
        revokeAllDevices,
        revokingId,
        revokingAll,
    };
}
